<template>
  <div class="app-header">
    <div class="app-header-logo">
      <h2><img style="width: 60px;height: 50px;float: left;" src="../../assets/logo.png">
        <span style="float: left;display: inline-block;line-height: 60px;">账户管理</span>
      </h2>
    </div>
    <el-row>
      <el-col :span="12">
        <el-tag type="success" size="large" style="margin:12px 10px 0 15px">{{area.province}}-{{area.city}}</el-tag>
        <el-tag type="primary" size="large" style="margin-top: 12px;margin-right: 10px">天气：{{weather.weather}}&nbsp;&nbsp; 气温：{{weather.temperature}}°&nbsp;&nbsp;
          风向描述：{{weather.winddirection}}{{weather.windpower}}级
        </el-tag>
        <el-tag type="info" size="large" style="margin-top: 12px">报告时间：{{weather.reporttime}}</el-tag>
      </el-col>
      <el-col :span="12">
        <div class="right-panel">
          <el-icon class="lock" @click="lockEvent">
            <Lock/>
          </el-icon>
          <!--          <el-dropdown>
                      <el-badge :value="3" class="el-dropdown-link bell">
                        <el-icon>
                          <Bell/>
                        </el-icon>
                      </el-badge>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item>21321321</el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>-->
          <el-icon class="refresh" @click="refreshAction">
            <Refresh/>
          </el-icon>
          <el-dropdown>
            <span class="el-dropdown-link user-link">
              <el-avatar class="user-avatar" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"/>
              <div class="user-name"> {{ user.nickName }}<el-icon>
                  <ArrowDown/>
                </el-icon></div>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :icon="User" @click="goToProfilePage">个人中心</el-dropdown-item>
                <el-dropdown-item :icon="SwitchButton" @click="logoutAction">
                  退出登陆
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script lang="ts" setup>
import {inject, onMounted, ref} from 'vue'
import {Lock, Bell, Refresh, User, SwitchButton, ArrowDown} from "@element-plus/icons-vue";
import R from "@/utils/r";
import UserService from "@/api/user";
import {useRouter} from "vue-router";
import NativeService from "@/api/native";
// eslint-disable-next-line no-undef
let emit = defineEmits(["lockEvent"]);

// 获取路由实例
const router = useRouter();
// 使用 inject 函数注入 userService 实例
const userService = inject('userService') as UserService;
const nativeService = inject('nativeService') as NativeService;
let user = ref({})

const logoutAction = () => {
  userService.logout().then((data: any) => {
    if (R.isSuccess(data)) {
      // localStorage.removeItem("token");
      router.push("/login")
    }
  });
}


const area = ref({});
const weather = ref({});
const getWeather = () => {
  nativeService.getArea().then((data: any) => {
    if (data.status == 1) {
      area.value = data;
      nativeService.getWeather({city:data.adcode}).then((data: any) => {
        if (data.status == 1) {
          weather.value = data.lives[0];
        }
      });
    }
  });
}


// 在组件挂载后获取数据
onMounted(async () => {
  // 调用服务端接口获取用户数据
  const initData = () => {
    userService.getPrincipal().then((data: any) => {
      if (R.isSuccess(data)) {
        user.value = data.t;
        if (data.t.isLock == 1) {
          lockEvent();
        }
      }
    });
  }

  initData();
  getWeather();
});

const lockEvent = () => {
  emit('lockEvent');
}

const goToProfilePage = () => {
  router.push("/profile")
}

const refreshAction = () => {
  window.location.reload();
}
</script>
<style>
.app-header {
  height: 60px;
  padding-right: 20px;
  padding-left: 8px;
  background: var(--el-color-white);
  box-shadow: 0 1px 0 rgba(0, 21, 41, .08);
}

.app-header-logo {
  width: 200px;
  float: left;
}

.app-header-logo h2 {
  margin: 0;
}

.right-panel {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: flex-end;
  height: 60px;
}

.bell,
.lock,
.refresh {
  margin-left: 20px;
  cursor: pointer;
}

.bell {
  font-size: 18px;
  margin-top: 3px;
}

.el-dropdown-link:focus-visible {
  outline: none;
}

.el-dropdown-link .user-name {
  position: relative;
  display: flex;
  flex-shrink: 0;
  align-content: center;
  align-items: center;
  height: 40px;
  margin-left: 6px;
  line-height: 40px;
  cursor: pointer;
}

.el-dropdown-link .user-avatar {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  margin-left: 15px;
  cursor: pointer;
  border-radius: 50%;
}


.user-link {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
}
</style>
